/** Strip verbose geo suffixes and title-case the result for display. */
export function cleanGeoLabel(raw: string): string {
  const cleaned = raw
    .replace(/ metropolitan area$/i, '')
    .replace(/ nonmetropolitan area$/i, ' Non-Metro');

  if (cleaned === raw) return raw;

  return cleaned.replace(/\b\w/g, (ch) => ch.toUpperCase());
}
